module.exports = __webpack_public_path__ + "static/media/ajuda.056304ea.png";